module.exports = __webpack_public_path__ + "img/tee-contra-logo.744ca0a3.png";